module.exports = __webpack_public_path__ + "img/billet_icon.7732973d.svg";